type Args = {
  text: string
  market?: string | null
}

export default function replaceCategoryVariables({ text, market }: Args) {
  if (!market) return text.replace(/\s?\[in_market\]\s?/g, '')

  return text.replace(/\[in_market\]/g, ` in ${market}`)
}
